import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import { formPagePath } from '../../utilities/route'
import { getUserRoles, ROLE_EDITOR, IMPROVEMENT_PROJECT_PHASE_ACTIVE, IMPROVEMENT_PROJECT_PHASE_ANALYSIS } from '../../utilities/helpers'

const NavMainAftergameLinks = ({
  activePage,
  surveyId,
  languageCode,
  useTranslate,
  isDialogueActive=false,
  showProgressReports=false,
  improvementProject
}) => {

  const to = formPagePath(languageCode, surveyId, 'finish');
  const toStatistics = to;
  const toDiscussion = formPagePath(languageCode, surveyId, 'finish', 'dialogue');
  const toProgressReports = formPagePath(languageCode, surveyId, 'finish', 'progress-reports');
  const toTargetsAndActions = `/v2${formPagePath(languageCode, surveyId, 'targets-and-actions')}`;

  const showTargetsAndActions = (improvementProject !== undefined) && (improvementProject !== null) && 
    ([IMPROVEMENT_PROJECT_PHASE_ACTIVE, IMPROVEMENT_PROJECT_PHASE_ANALYSIS].includes(improvementProject.phase) || (getUserRoles(surveyId).includes(ROLE_EDITOR)))
  return (
    <Fragment>
      <li className={`nav-item ${activePage === "statistics" ? "active" : ""}`}>
        <Link to={toStatistics} className="nav-link">
          {useTranslate("data_vault.statistics")}
        </Link>
      </li>
      {showProgressReports &&
        <li className={`nav-item ${activePage === "progress" ? "active" : ""}`}>
          <Link to={toProgressReports} className="nav-link">
            {useTranslate("progress_reports.progress_main_nav_text")}
          </Link>
        </li>
      }
      {showTargetsAndActions &&
          <li className={`nav-item ${activePage === "targets-and-actions" ? "active" : ""}`}>
            <a href={toTargetsAndActions} className="nav-link">
              {useTranslate("targets_and_actions_common.module_title")}
            </a>
          </li>
      }
      {isDialogueActive &&
        <li className={`nav-item ${activePage === "discussion" ? "active" : ""}`}>
          <Link to={toDiscussion} className="nav-link">
            {useTranslate("data_vault.discussion")}
          </Link>
        </li>
      }
    </Fragment>
  )
}

export default NavMainAftergameLinks;


// WEBPACK FOOTER //
// ./src/components/navigation/nav-main-aftergame-links.js